import { graphql } from '@/generated/gql';

export const NEGOTIATION_SETTINGS_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationSettingsMutation($id: UUID!, $data: TsrctNegotiationCaseNegotiationSettingsInput!) {
    tesseract {
      negotiationCase(id: $id) {
        updateNegotiationSettings(data: $data) {
          id
          isNegotiationEnabled
          isSupplierUploadAllowed
          lowerDiscountBoundary
          upperDiscountBoundary
          strategy {
            id
            useHistoricTenderData
            useHistoricNegotiationData
            boundaryRules {
              id
              base
              lower
              upper
              sequence
            }
          }
          options {
            id
            initiatedBy
            quoteMode
            negotiationMode
            supplierInteractionMode
            negotiationObjective
          }
        }
      }
    }
  }
`);
